import { mapGetters } from 'vuex'

import {
  IS_SMS_VENDOR,
  searchCriteria,
  purposes,
  sizeModels,
  planningPeriods,
  planningYears,
  classCodes,
  subClassCodes,
  flowLongDescriptions,
  ssns,
  distros,
  gisAgents,
  gisAgentCodes,
  coos,
  inStoreDates,
  brandCodes,
  divisionCodes,
  departmentCodes,
  categoryCodes,
  subCategoryCodes,
  linePlans,
  itemTypes,
  shipToAttns,
  deactivatedPurposes,
  productTypes,
  deactivatedAdSampleTypes,
  sampleMarkets,
  plmSampleTypes,
  marketCodes,
  seasonalWorkspace,
  productTeam,
  requestPurpose,
  rawMaterialType,
  materialAction,
  smrStatus,
  smrSearchParamsCache,
  devSearchParamsCache,
  cocCatalogs,
  svdOffice,
  gauge,
  end,
  roundNum,
  cocSubCategory,
  keyCostDriver,
  cocFabric,
  age,
  gender,
  smrOrderingTimeliness,
  flowNames,
  orderingTimelinesss
} from './definition'

import {
  ACCESS_GROUPS
} from 'src/store/definition'

export default {
  [IS_SMS_VENDOR] (state, getters) {
    return getters[ACCESS_GROUPS].some(accessGroup => {
      return accessGroup.accessGroup === 'SMS_VENDOR_AD' || accessGroup.accessGroup === 'SMS_VENDOR_DEV_SAMPLE' ||
       accessGroup.accessGroup === 'SMS_VENDOR_COCREATION' || accessGroup.accessGroup === 'SMS_VENDOR_TOP'
    })
  },
  [searchCriteria] (state) {
    return state.smsSearchCriteria
  },
  [productTypes] (state, getters) {
    return state.productTypes
  },
  [purposes] (state, getters) {
    return state.purposes
  },
  [sizeModels] (state, getters) {
    return state.sizeModels
  },
  [planningPeriods] (state, getters) {
    return state.planningPeriods
  },
  [planningYears] (state, getters) {
    return state.planningYears
  },
  [shipToAttns] (state, getters) {
    return state.shipToAttns
  },
  [classCodes] (state, getters) {
    return state.classCodes
  },
  [subClassCodes] (state, getters) {
    return state.subClassCodes
  },
  [flowLongDescriptions] (state, getters) {
    return state.flowLongDescriptions
  },
  [ssns] (state, getters) {
    return state.ssns
  },
  [distros] (state, getters) {
    return state.distros
  },
  [gisAgents] (state, getters) {
    return state.gisAgents
  },
  [gisAgentCodes] (state, getters) {
    return state.gisAgentCodes
  },
  [coos] (state, getters) {
    return state.coos
  },
  [inStoreDates] (state, getters) {
    return state.inStoreDates
  },
  [brandCodes] (state, getters) {
    return state.brandCodes
  },
  [divisionCodes] (state, getters) {
    return state.divisionCodes
  },
  [departmentCodes] (state, getters) {
    return state.departmentCodes
  },
  [categoryCodes] (state, getters) {
    return state.categoryCodes
  },
  [subCategoryCodes] (state, getters) {
    return state.subCategoryCodes
  },
  [itemTypes] (state, getters) {
    return state.itemTypes
  },
  [linePlans] (state, getters) {
    return state.linePlans
  },
  [deactivatedPurposes] (state, getters) {
    return state.deactivatedPurposes
  },
  [deactivatedAdSampleTypes] (state, getters) {
    return state.deactivatedAdSampleTypes
  },
  [sampleMarkets] (state, getters) {
    return state.sampleMarkets
  },
  [plmSampleTypes] (state, getters) {
    return state.plmSampleTypes
  },
  [marketCodes] (state, getters) {
    return state.marketCodes
  },
  [seasonalWorkspace] (state, getters) {
    return state.seasonalWorkspace
  },
  [productTeam] (state, getters) {
    return state.productTeam
  },
  [requestPurpose] (state, getters) {
    return state.requestPurpose
  },
  [rawMaterialType] (state, getters) {
    return state.rawMaterialType
  },
  [materialAction] (state, getters) {
    return state.materialAction
  },
  [smrStatus] (state, getters) {
    return state.smrStatus
  },
  [smrSearchParamsCache] (state, getters) {
    return state.smrSearchParamsCache
  },
  [devSearchParamsCache] (state, getters) {
    return state.devSearchParamsCache
  },
  [cocCatalogs] (state, getters) {
    return state.cocCatalogs
  },
  [svdOffice] (state, getters) {
    return state.svdOffice
  },
  [gauge] (state, getters) {
    return state.gauge
  },
  [end] (state, getters) {
    return state.end
  },
  [roundNum] (state, getters) {
    return state.roundNum
  },
  [cocSubCategory] (state, getters) {
    return state.cocSubCategory
  },
  [keyCostDriver] (state, getters) {
    return state.keyCostDriver
  },
  [cocFabric] (state, getters) {
    return state.cocFabric
  },
  [age] (state, getters) {
    return state.age
  },
  [gender] (state, getters) {
    return state.gender
  },
  [smrOrderingTimeliness] (state, getters) {
    return state.smrOrderingTimeliness
  },
  [flowNames] (state, getters) {
    return state.flowNames
  },
  [orderingTimelinesss] (state, getters) {
    return state.orderingTimelinesss
  }
}

export const getters = mapGetters({
  IS_SMS_VENDOR,
  purposes,
  sizeModels,
  planningPeriods,
  planningYears,
  classCodes,
  subClassCodes,
  flowLongDescriptions,
  ssns,
  distros,
  gisAgents,
  gisAgentCodes,
  coos,
  inStoreDates,
  brandCodes,
  divisionCodes,
  departmentCodes,
  categoryCodes,
  subCategoryCodes,
  itemTypes,
  linePlans,
  shipToAttns,
  deactivatedPurposes,
  deactivatedAdSampleTypes,
  sampleMarkets,
  plmSampleTypes,
  marketCodes,
  seasonalWorkspace,
  productTeam,
  requestPurpose,
  rawMaterialType,
  materialAction,
  smrStatus,
  smrSearchParamsCache,
  devSearchParamsCache,
  cocCatalogs,
  svdOffice,
  gauge,
  end,
  roundNum,
  cocSubCategory,
  keyCostDriver,
  cocFabric,
  age,
  gender,
  smrOrderingTimeliness,
  flowNames,
  orderingTimelinesss
})



// WEBPACK FOOTER //
// ./src/components/samplemanagement/common/store/getters.js